import { render, staticRenderFns } from "./ContactsTable.vue?vue&type=template&id=4e49c56e"
import script from "./ContactsTable.vue?vue&type=script&lang=ts"
export * from "./ContactsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports